import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BuildingIcon, UserIcon, TargetIcon, DollarSignIcon, ZapIcon } from 'lucide-react';
const overviewCards = [{
  icon: BuildingIcon,
  label: 'Business',
  value: 'Be Clinical Med Spa',
  detail: '3130 Crow Canyon Pl, San Ramon, CA 94583'
}, {
  icon: UserIcon,
  label: 'Medical Director',
  value: 'Dr. Fiona Frie, MD',
  detail: 'Board Certified Physician'
}, {
  icon: TargetIcon,
  label: 'Goal',
  value: '150 Bookings',
  detail: 'Per Month Target'
}, {
  icon: DollarSignIcon,
  label: 'Monthly Ad Spend',
  value: '$20,000',
  detail: 'Google Search Ads'
}];
export function OverviewSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="overview" className="py-24 md:py-32 bg-white" ref={ref} data-id="element-130">
      <div className="max-w-6xl mx-auto px-6" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-132">
          <p className="text-[#C9A96E] text-sm font-semibold tracking-[0.2em] uppercase mb-3" data-id="element-133">
            Overview
          </p>
          <h2 className="text-3xl md:text-4xl font-light text-[#1B2A4A]" data-id="element-134">
            Campaign Summary
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-135">
          {overviewCards.map((card, index) => <motion.div key={card.label} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#F8F9FA] rounded-2xl p-6 border border-[#1B2A4A]/5" data-id="element-136">
              <div className="w-12 h-12 rounded-xl bg-[#1B2A4A] flex items-center justify-center mb-4" data-id="element-137">
                <card.icon className="w-6 h-6 text-[#C9A96E]" data-id="element-138" />
              </div>
              <p className="text-sm text-[#666] mb-1" data-id="element-139">{card.label}</p>
              <p className="text-xl font-semibold text-[#1B2A4A] mb-1" data-id="element-140">
                {card.value}
              </p>
              <p className="text-sm text-[#666]" data-id="element-141">{card.detail}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-gradient-to-br from-[#1B2A4A] to-[#2A3F6A] rounded-3xl p-8 md:p-12 text-white" data-id="element-142">
          <div className="flex items-start gap-4 mb-6" data-id="element-143">
            <div className="w-12 h-12 rounded-xl bg-[#C9A96E]/20 flex items-center justify-center flex-shrink-0" data-id="element-144">
              <ZapIcon className="w-6 h-6 text-[#C9A96E]" data-id="element-145" />
            </div>
            <div data-id="element-146">
              <h3 className="text-xl font-semibold mb-2" data-id="element-147">Our Strategy</h3>
              <p className="text-white/70 leading-relaxed" data-id="element-148">
                Google Search Ads targeting high-intent patients actively
                searching for your services in the San Ramon / Tri-Valley area.
              </p>
            </div>
          </div>
          <div className="pl-16" data-id="element-149">
            <p className="text-white/90 leading-relaxed" data-id="element-150">
              Your ads will only show to people physically located in your
              service area who are actively searching for the treatments you
              offer.{' '}
              <span className="text-[#C9A96E] font-medium" data-id="element-151">
                Every dollar goes toward reaching patients who are ready to
                book.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}